// @ts-nocheck

import minBy from 'lodash/minBy';
import maxBy from 'lodash/maxBy';
import moment from 'moment';



export const getMinMaxWaypointDateTime = (waypoints = []) => {
  let dateTimeList = [];
  waypoints.forEach((waypoint) => {
    if (waypoint.arrivedDateTime) {
      dateTimeList.push(waypoint.arrivedDateTime);
    }
    if (waypoint.departureDateTime) {
      dateTimeList.push(waypoint.departureDateTime);
    }
  });
  return {
    min: minBy(dateTimeList, (dateTime) => moment.utc(dateTime)),
    max: maxBy(dateTimeList, (dateTime) => moment.utc(dateTime))
  };
};